import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import styles from "./vehicleLogComponent.module.scss";
import LicensePlateComponent from "./../../../../components/licensePlateComponent/LicensePlateComponent";
import SubTitleHeader from "../../../../components/subTitleHeader/SubTitleHeader";
import LogDetailsComponent from "../../../../components/logDetailsComponent/LogDetailsComponent";
import _ from "lodash";
import TwoButtonFooterSection from "../../../../components/TwoButtonFooterSection/TwoButtonFooterSection";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import {
  getVehicleLogs,
  getVehicleLogsCSV,
} from "../../../../services/APIService";
import { downloadCsv } from "../../../../config/appConfig";
import PropTypes from "prop-types";

const VehicleLogComponent = (props) => {
  const { onBack, start, setStart, id } = props;
  const [vehicelsLogDetails, setVehicelsLogDetails] = useState({});
  const { setApiErrorModalState } = useApiErrorModalContext();
  const fetchVehicleLogs = useCallback(() => {
    getVehicleLogs({ vehicleId: id })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setVehicelsLogDetails(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadVehicleLog = () => {
    getVehicleLogsCSV({ vehicleId: id })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          downloadCsv(response.fileData, response.fileName);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  useEffect(() => {
    fetchVehicleLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box className={styles.logsWrapper} data-testid="VehicleLogComponent">
      <Box className={styles.logsWrapper1}>
        <Box className={styles.logsWrapper2}>
          <Box className={styles.logsWrapper3}>
            <LicensePlateComponent
              platenumber={_.get(vehicelsLogDetails, "licenceNumber", "-")}
            />
          </Box>
          <Box className={styles.logsWrapper4}>
            <SubTitleHeader title="Data vehicle log" />

            <LogDetailsComponent
              logData={_.get(vehicelsLogDetails, "logs", [])}
              start={start}
              setStart={setStart}
              type="vehicle"
            />
          </Box>
        </Box>

        <TwoButtonFooterSection
          btnlist={[
            {
              title: "Back",
              iconStyle: styles.Back,
              buttonType: "muibtn-secondary-with-border",
              attriType: "button",
              withIcon: true,
              showCountSection: false,
              count: "",
              handleClick: () => {
                onBack();
              },
              position: "left",
            },
            {
              title: "Download log",
              iconStyle: "",
              buttonType: "muibtn-primary",
              attriType: "button",
              withIcon: false,
              showCountSection: false,
              count: "",
              handleClick: () => downloadVehicleLog(),
              position: "right",
              isDisabled: false
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default VehicleLogComponent;
VehicleLogComponent.propTypes = {
  onBack:PropTypes.any, 
  start:PropTypes.any, 
  setStart:PropTypes.any, 
  id:PropTypes.any
}
